import React from 'react';
import CONFIG from '../../config';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';


function WidgetFile({ id_client, type_dossier, document_name, index, path, name, setUser, locked = false }) {
  const navigate = useNavigate();
  const handleClickView = React.useCallback((e) => {
    axios.get(CONFIG.API_URL + '/api/client_download_file/' + id_client + '/' + type_dossier + '/' + document_name + '/' + index, { responseType: 'blob', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            window.open(URL.createObjectURL(response.data), "_blank");
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;
        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;

          default:
            break;
        }
      });
  }, []);

  const handleClickDelete = React.useCallback((e) => {
    axios.delete(CONFIG.API_URL + '/api/client_delete_file/' + id_client + '/' + type_dossier + '/' + document_name + '/' + index, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;
        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;

          default:
            break;
        }
      });
  }, []);

  return (
    <>
      <div className="col-span-12 h-min flex pl-2 mb-2 mr-2 items-center bg-gray-100 rounded-md shadow-md shadow-gray-100 justify-center border border-gray-200">
        <div className="grow whitespace-nowrap pr-2 text-ellipsis overflow-hidden">
          {name}
        </div>
        <div className="flex">
          <IconButton onClick={handleClickView}><VisibilityIcon fontSize="small"></VisibilityIcon></IconButton>
        </div>
        {!locked &&
          <div className="flex">
            <IconButton onClick={handleClickDelete}><CloseIcon fontSize="small"></CloseIcon></IconButton>
          </div>
        }
      </div>
    </>
  );
}

export default WidgetFile;